import { Unity } from "./unity";

export class ExtraExpense {
    id:number = 0;
    expense_type_id:number = 0;
    unity_id:number = 0;
    unity:Unity = new Unity();
    expense_type_name:string = '';
    article_id:number = 0;
    article_name:string = '';
    description:string = '';
    quantity:number = 0;
    price:number = 0;
    expense_date:Date = new Date();
    iva:number = 0.16;
    active:boolean = true;
}
